module.exports = __webpack_public_path__ + "static/media/store_fasttrack.jpg.eda53425.bak";